import { render } from "./TenisForm.vue?vue&type=template&id=4f515848&scoped=true&ts=true"
import script from "./TenisForm.vue?vue&type=script&lang=ts"
export * from "./TenisForm.vue?vue&type=script&lang=ts"

import "./TenisForm.vue?vue&type=style&index=0&id=4f515848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f515848"]])

export default __exports__